import { Toaster } from 'react-hot-toast';

import { App } from 'applications/GSP/app/App';
import { ProtectedRoute } from 'applications/GSP/app/providers/RouterProvider/components/ProtectedRoute';
import { RootBoundary } from 'applications/GSP/app/providers/RouterProvider/components/RootBoundary';
import { CookiesPreferences } from 'applications/GSP/features/CookiesPreferences';
import { MainLayout } from 'applications/GSP/layouts/MainLayout';
import { RootRoutePath } from 'applications/GSP/shared/constants/router';

import {
  useAdminRoutesConfig,
  useMainRoutesConfig,
  useSystemRoutesConfig,
} from './hooks';
import { getRoutesByRole } from './utils';

import type { UserRole } from 'applications/GSP/shared/types';
import type { RouteObject } from 'shared/types';

export const useMainRoutes = (role: UserRole): RouteObject[] => {
  const adminConfig = useAdminRoutesConfig();
  const mainConfig = useMainRoutesConfig();
  const systemConfig = useSystemRoutesConfig();

  return [
    {
      path: RootRoutePath.Home,
      element: (
        <App>
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
          <Toaster />
          <CookiesPreferences />
        </App>
      ),
      errorElement: <RootBoundary />,
      children: [
        ...getRoutesByRole(role, [...adminConfig, ...mainConfig]),
        ...systemConfig,
        {
          path: RootRoutePath.NotFound,
          handle: { crumb: null },
          lazy: () =>
            import('shared/components/NotFound').then(({ NotFound }) => ({
              Component: NotFound,
            })),
        },
      ],
    },
  ];
};
